import { api, defaultQueriesFor } from '../apiSlice';

export const podApi = api
  .enhanceEndpoints({ addTagTypes: ['Pod'] })
  .injectEndpoints({
    endpoints: build => ({
      ...defaultQueriesFor(build, 'Pod', 'Pods', true),
    }),
  });

export const {
  useCreatePodMutation,
  useDeletePodMutation,
  useGetPodByIdQuery,
  useGetPodsQuery,
  useUpdatePodMutation,
} = podApi;
